<template>
  <div
    class="modal-container"
    :class="[{ mini: isMini, 'is-visible': isVisible }]"
  >
    <div class="hider" ref="hider" @click.prevent="hide"></div>
    <div class="modal-wrapper" ref="modalWrapper">
      <div class="modal-content-container area">
        <div class="hider" ref="hider" @click.prevent="hide"></div>
        <div class="modal-content">
          <slot></slot>
          <a
            class="nav-arrow nav-arrow--close"
            href="/"
            @click.prevent="
              () => {
                hide();
              }
            "
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalDialog",
  props: {
    isMini: Boolean,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    show() {
      this.isVisible = true;
      if (!this.isMini) {
        document.body.classList.add("stop-scrolling");
        document.body.classList.add("stop-scrolling-modal");
        var root = document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)
        root.setAttribute("class", "stop-scrolling stop-scrolling-modal");
      }
    },
    hide() {
      this.isVisible = false;
      if (!this.isMini) {
        document.body.classList.remove("stop-scrolling");
        document.body.classList.remove("stop-scrolling-modal");
        var root = document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)
        root.setAttribute("class", "");
        root.setAttribute("class", "");
      }
      this.$emit("hide");
    },
  },
  created() {
    document.onkeydown = evt => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.hide();
      }
    };
  },
};
</script>

<style lang="scss">
.stop-scrolling-modal {
  .app-content {
    @media all and (max-width: $md) {
      display: none;
    }
  }
  .menu-buttons {
    @media all and (max-width: $md) {
      display: none;
    }
  }
}
.modal-container {
  @media all and (max-width: $md) {
    position: relative;
    height: unset;
    background: $bg-main;
    transition: unset;
    display: none;
  }
  transition: background-color 0.4s ease-in-out;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  background: transparent;
  min-height: 100vh;
  height: 100vh;
  display: block;
  touch-action: none;
  pointer-events: none;

  &.is-visible {
    @media all and (max-width: $md) {
      background: $bg-main;
    }
    top: 0;
    touch-action: unset;
    pointer-events: unset;
    display: block;
    background: $bg-popup-darken;
    .modal-wrapper {
      top: 0;
    }
    z-index: 1000;
  }
  .modal-wrapper {
    @media all and (max-width: $md) {
      position: relative;
      overflow-y: unset;
      overflow-x: unset;
      height: unset;
      transition: unset;
    }
    transition: all 0.4s ease-in-out;
    position: relative;
    top: 100vh;
    height: 100vh;
    overflow-y: scroll;
    width: 100%;
    overflow-x: hidden;
    .modal-content-container {
      @media all and (max-width: $lg) {
        right: unset;
        grid-template-rows: unset;
      }
      min-height: 100vh;
      right: -10px;
      position: relative;
      display: grid;
      grid-template-rows: auto 1fr auto;
      justify-self: center;
      .modal-content {
        @media all and (max-width: $md) {
          margin-top: 0;
          margin-bottom: 60px;
          padding: unset;
          padding-top: 17px;
        }
        position: relative;
        background: $bg-main;
        padding: 58px 56px;
        margin-top: 110px;
        margin-bottom: 110px;
      }
    }
  }
  .nav-arrow {
    @media all and (max-width: $lg - 1) {
      right: 28px;
    }
    @media all and (max-width: $md) {
      left: unset;
      right: 10px;
      top: -58px;
      transform: unset;
    }
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 0;
    width: 40px;
    height: 40px;
    padding: 0;
    background: $color-accent;
    cursor: pointer;
    display: grid;
    text-decoration: none;
    justify-content: center;
    align-content: center;
    border-radius: 50%;
    &::before {
      font-family: fontello;
      font-weight: 300;
      font-size: 12px;
    }
    &.nav-arrow--close {
      color: $bg-main;
      transition: background-color 0.5s;
      &::before {
        content: "\e819";
        color: $bg-main;
        transition: transform 0.5s;
        transform: rotate(0deg);
      }
      &:hover {
        background: $color-error;
        &::before {
          transition: transform 0.5s;
          transform: rotate(360deg);
        }
      }
    }
    &:hover {
      transition: background-color 0.5s transform 0.5s;
      background: $color-accent;
      &::before {
        transition: color 0.5s;
        color: $text-inverse-main;
      }
    }
  }
  .hider {
    @media all and (max-width: $md) {
      display: none;
    }
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
